import { Repository } from 'aurelia-orm';
import { Invite } from 'data/entities/entities';
import { AttachmentInfo } from 'data/entities/attachment-info';

export class AttachmentInfoRepository extends Repository {

	listAttachments(parentGuid: string, entityStatusId: number) {
		return this.find({ entityStatusIs: entityStatusId })
		//return this.http.get(this.baseUrl + "list?parentGuid=" + parentGuid + "&entityStatusId=" + entityStatusId);
	}

	//save(attachmentInfo: AttachmentInfo) {
	//	return this.find('save')
	//	return this.http.post(this.baseUrl + "save", attachmentInfo);
	//}

	//findByInviteStatusId(inviteStatusId: number) {
	//	return this.find({inviteStatusId: inviteStatusId})
	//}

	//checkForDuplicateEmail(email: string) {
	//	return this.find(`validateEmail?email=${email}`, true);
	//}

}
